import React from 'react';
import { useHistory } from 'react-router-dom';

function EmptyQuietTimeListMessage() {
  const history = useHistory();
  return (
    <div className="card">
      <div className="card-body text-left">
        {/* <h4>Managing alert notifications is simple. Here&#39;s what you need to know:</h4> */}
        <ul>
          <li>
            Schedule quiet times to silence alert notifications during certain time periods.
          </li>
          <li>
            1 quiet time can be associated with multiple alerts (and vice-versa).
          </li>
          <li>
            Learn more:
            {' '}
            <a target="_blank" rel="noopener noreferrer" href="https://avtech.com/articles/11432/">How To Create Quiet Times In Room Alert Account</a>
            .
          </li>
        </ul>
        <div className="my-3 row">
          <div className="col">
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => history.push('/s/actions/quiet-times/new')}
            >
              Create quiet time
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EmptyQuietTimeListMessage;
